import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=4b4c406d&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=4b4c406d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c406d",
  null
  
)

export default component.exports